import { AnalysisItem, GroupedResultFathom } from "helpers/models";

const getDefendedValueLabel = (
  item: AnalysisItem,
  key = "Defended"
): string => {
  try {
    const details = (item as any)?.details;
    const data = details?.[key] ? JSON.parse(details[key]) : [];
    const floodItem = data.find((i: any) => parseFloat(i?.depth) > 0);

    return (
      (floodItem?.returnPeriod
        ? `${floodItem.returnPeriod} years`
        : data?.[0]?.valueLabel) ?? "No Data"
    );
  } catch {
    return "No Data";
  }
};

export default (analysisItems: AnalysisItem[]): GroupedResultFathom => {
  const result = analysisItems.reduce((acc: GroupedResultFathom, item) => {
    const { layerId, details, valueLabel, defendeValueLabel } = item;

    // 1. 初始化图层结构
    if (!acc[layerId]) {
      acc[layerId] = {
        defended: {},
        undefended: {}
      };
    }

    if (layerId === "FL_Pluvial_Global_Fathom") {
      if (!valueLabel) {
        return acc;
      }
      const dLabel = valueLabel;
      if (!acc[layerId].defended[dLabel]) {
        acc[layerId].defended[dLabel] = [];
      }
      acc[layerId].defended[dLabel].push(item);
    }

    if (!details) {
      return acc;
    }

    // 2. 处理 Defended 分组（与页面逻辑一致：优先解析 details.Defended）
    if (details.Defended || defendeValueLabel) {
      const dLabel = details.Defended
        ? getDefendedValueLabel(item)
        : defendeValueLabel || "No Data";
      if (!acc[layerId].defended[dLabel]) {
        acc[layerId].defended[dLabel] = [];
      }
      acc[layerId].defended[dLabel].push(item);
    }

    // 3. 处理 Undefended 分组 (基于 valueLabel)
    if (details.Undefended && valueLabel) {
      const uLabel = valueLabel;
      if (!acc[layerId].undefended[uLabel]) {
        acc[layerId].undefended[uLabel] = [];
      }
      acc[layerId].undefended[uLabel].push(item);
    }

    return acc;
  }, {});

  return result;
};
